import { DEFAULT_NETWORK } from '@cronos-app/sdk';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
/**
 * prevent from using this store directly, use wrapped hooks instead
 */
export const useGlobalContextStore = create(persist(() => ({
    network: DEFAULT_NETWORK,
}), {
    name: '__GLOBAL_CONTEXT__',
    version: 3,
}));
export const useOverrideGlobalContextStore = create(() => ({
    network: null,
}));
